(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["euphoria-home-media"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('euphoria-editorial')) {
  customElements.define('euphoria-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[data-editorial-tab]')];
      const panels = [...this.querySelectorAll('[data-editorial-panel]')];
      const select = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.editorialPanel !== tab.dataset.editorialTab; });
        if (tab.dataset.editorialTab !== 'media') this.querySelector('video')?.pause();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next]);
          tabs[next].focus({preventScroll:true});
        });
      });
      select(tabs[0]);
      this.querySelector('[role=tablist]').hidden = false;
    }
  });
}
if (!customElements.get('euphoria-media')) {
  customElements.define('euphoria-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cover = this.querySelector('.em-media__cover');
      const template = this.querySelector('template');
      if (!cover || !template) return;
      cover.addEventListener('click', () => {
        const video = template.content.querySelector('video').cloneNode(true);
        const sources = [...video.querySelectorAll('source')].sort((a,b) => Number(a.dataset.width) - Number(b.dataset.width));
        const target = matchMedia('(max-width: 749px)').matches ? 852 : 1920;
        const selected = sources.find(source => Number(source.dataset.width) >= target) || sources[sources.length - 1];
        if (!selected) return;
        sources.forEach(source => { if (source !== selected) source.remove(); });
        const status = this.querySelector('.em-media__status');
        video.addEventListener('error', () => { status.hidden = false; });
        video.addEventListener('playing', () => { status.hidden = true; });
        cover.replaceWith(video);
        video.focus({preventScroll: true});
        video.play().catch(() => { status.hidden = false; });
      }, {once: true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.upwardScrollDistance = 0;
      this.downwardScrollDistance = 0;
      this.isHomePage = this.dataset.homePage === "true";
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.downwardScrollDistance += scrollTop - this.currentScrollTop;
        this.header.classList.add('scrolled-past-header');
        if (!this.isHomePage || this.downwardScrollDistance >= 40) {
          this.upwardScrollDistance = 0;
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.downwardScrollDistance = 0;
        this.header.classList.add('scrolled-past-header');
        this.upwardScrollDistance += this.currentScrollTop - scrollTop;
        if (!this.preventReveal) {
          if (!this.isHomePage || this.upwardScrollDistance >= this.header.offsetHeight * 6) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          this.upwardScrollDistance = 0;
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.upwardScrollDistance = 0;
        this.downwardScrollDistance = 0;
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
